module.exports = __webpack_public_path__ + "static/media/featured_listing_1.dd252fc0.jpg";